export default function($stateProvider) {
    $stateProvider
        .state('login', {
        url: '/login',
        template: '<auth></auth>',
        data: {
            specialClass: 'blank'
        }
    });
}



// WEBPACK FOOTER //
// ./app/components/auth/states.js